// extracted by mini-css-extract-plugin
module.exports = {"background":"Gallery_background__m_gOe","button":"Gallery_button__Y9FJC","gallery":"Gallery_gallery__h_qOq","slider":"Gallery_slider__yurIR"};